// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__qVPQy","footer":"ModalFilter_footer__PoGry"};